module.exports = __webpack_public_path__ + "static/media/5.95a47335.jpg";